export default () => {
  // Additional behavior to clear the hidden input if it is empty
  const forms = document.querySelectorAll(".quick-search form");

  forms.forEach(form => {
    form.addEventListener("submit", e => {
      const typeInput = form.querySelector('input[name="vu-document-types"]');

      if (typeInput && typeInput.value.trim() === "") {
        typeInput.remove(); // removes the input if it's empty so it doesn't get added to the URL
      }
    });
  });
};
